import { render, staticRenderFns } from "./RealtyRequestCompare.vue?vue&type=template&id=15cd3926&"
import script from "./RealtyRequestCompare.vue?vue&type=script&lang=js&"
export * from "./RealtyRequestCompare.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports